import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Col from 'reactstrap/lib/Col';
import { get, isEmpty } from 'lodash-es';
import {
  AdComponentPropTypes,
  AdComponentDefaultProps,
} from 'client/site-modules/shared/components/ad-unit/ad-unit-prop-types';
import { ComparatorIncentivesSiteServedAd } from 'client/site-modules/shared/components/native-ad/comparator-incentives-site-served-ad/comparator-incentives-site-served-ad';
import { NativeAd } from 'site-modules/shared/components/ad-unit/native-ad';
import { INCENTIVES_AD } from 'client/site-modules/shared/components/native-ad/utils/constants';
import { withSiteServedAdWrapper } from 'client/site-modules/shared/components/native-ad/site-served-ad-wrapper/site-served-ad-wrapper';
import {
  IncentivesCreativeConfigDefaultProps,
  IncentivesCreativeConfigPropTypes,
} from 'client/data/models/native-ads-creative-config';
import { parseVehicleForAction } from 'client/utils/parse-vehicle-for-action';

const DATA_TEST = 'dfp-incentives-ad';

export function ComparatorIncentivesAdUI({
  wrapperClass = AdComponentDefaultProps.wrapperClass,
  mobile = AdComponentDefaultProps.mobile,
  slotRenderEndListener = AdComponentDefaultProps.slotRenderEndListener,
  withDFPFallback,
  siteServedAdsEnabled = AdComponentDefaultProps.siteServedAdsEnabled,
  position = AdComponentDefaultProps.position,
  creativeConfig = IncentivesCreativeConfigDefaultProps,
  vehicle = AdComponentDefaultProps.vehicle,
  showOnlyDFP = false,
  currentVehicle = AdComponentDefaultProps.currentVehicle,
  ivtClassName = AdComponentDefaultProps.ivtClassName,
}) {
  const SiteServedIncentive = (
    <Col xs={12} className={classnames(wrapperClass, ivtClassName)}>
      <ComparatorIncentivesSiteServedAd
        mobile={mobile}
        position={position}
        creativeConfig={creativeConfig}
        vehicle={vehicle}
        currentVehicle={currentVehicle}
      />
    </Col>
  );

  return (
    <Fragment>
      {withDFPFallback && (showOnlyDFP || mobile) ? (
        <Col xs={12} className={classnames(wrapperClass, ivtClassName)} data-test={DATA_TEST}>
          <NativeAd
            refreshDisableWhenZipChanged={siteServedAdsEnabled}
            wiredBreakpoints={{
              lg: true,
              xl: true,
            }}
            nativeStyle="vdp"
            slotRenderEndListener={slotRenderEndListener}
            currentVehicle={currentVehicle}
            position={position}
            siteServedAdsUpdater={get(creativeConfig, 'siteServedAdsUpdater')}
          />
        </Col>
      ) : (
        !showOnlyDFP && SiteServedIncentive
      )}
    </Fragment>
  );
}

ComparatorIncentivesAdUI.propTypes = {
  ...AdComponentPropTypes,
  creativeConfig: IncentivesCreativeConfigPropTypes,
  showOnlyDFP: PropTypes.bool,
};

const ComparatorIncentivesAdWrapper = withSiteServedAdWrapper(ComparatorIncentivesAdUI);

export function ComparatorIncentivesAd(props) {
  const { style, showOnlyDFP } = props;

  let currentVehicle = null;
  if (!isEmpty(style)) {
    currentVehicle = parseVehicleForAction(style);
  } else if (!showOnlyDFP) return null;

  return <ComparatorIncentivesAdWrapper {...props} adType={INCENTIVES_AD} currentVehicle={currentVehicle} />;
}
